<app-dialogue-box [isDialogOpen]="isDialogOpen" [title]="dialogTexts.DELETE_REPORT.TITLE"
  [message]="dialogTexts.DELETE_REPORT.MESSAGE" [confirmButtonText]="dialogTexts.DELETE_REPORT.CONFIRM"
  (onClose)="closeDialog()" (onConfirm)="deleteReport(selectedReportId)">
</app-dialogue-box>
<app-loader *ngIf="isLoading"></app-loader>
<div class="report-list-container">
  <div class="report-list-header">
    <div class="welcome-block">
      <div class="welcome-icon-wrap">
        <img src="/assets/icons/dashboard-analytics.svg" alt="Dashboard" />
      </div>
      <div class="welcome-copy">
        <h1 class="user-welcome">Hello, <span>{{name}}</span></h1>
        <p class="welcome-subtitle">Here's what's happening with your reports</p>
      </div>
    </div>
    <app-chart-data-v2></app-chart-data-v2>
  </div>
  <div class="reports-card">
    <div class="list-header">
      <div class="recent-reports-summary" aria-label="Recent reports summary">
        <div class="summary-icon-wrap">
          <img src="/assets/icons/report_green.svg" alt="Recent Reports" />
        </div>
        <div class="summary-text">
          <span class="report-count">{{reports().length}}</span>
          <span class="report-label">Recent Reports</span>
        </div>
      </div>
      <div class="header-actions">
        <button class="action-buttons" type="button" (click)="loadReports()">
          <img src="/assets/icons/report_green.svg" alt="All Reports" />
          Refresh Reports
        </button>
        <button class="action-buttons" type="button" (click)="enableGridFilters()">
          <img src="/assets/icons/filter_alt_32.svg" alt="Filters" />
          Filters
        </button>
      </div>
    </div>
    <div class="grid-wrapper">
      <ag-grid-angular class="custom-grid" style="width: 100%; height: 100%;"
        [rowData]="reports()" 
        [columnDefs]="columnDefs" 
        [context]="{ componentParent: this }"
        overlayNoRowsTemplate="No reports found" 
        [headerHeight]="40" 
        [gridOptions]="gridOptions" 
        [defaultColDef]="{
          sortable: false,
          resizable: true,
          filter: this.isFilterEnabled,
          flex: 1,
          minWidth: 140
        }"
        [suppressDragLeaveHidesColumns]="true"
        (bodyScrollEnd)="onGridBodyScrollEnd($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>